import { Head } from '@inertiajs/react';
import { TelescopeInspector } from '@/components/elt/inspector';
import type { LandingsTelescope } from '@/types';

// GET /26-cl/telescope — the hero's ELT on its own, to inspect and work on the model.
export default function Telescope({ title, description }: LandingsTelescope) {
  return (
    <>
      <Head title={title}>
        <meta name="description" content={description} />
        <meta name="robots" content="noindex" />
      </Head>
      <TelescopeInspector />
    </>
  );
}
